import script from "./SearchIndividualStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchIndividualStudent.vue?vue&type=script&setup=true&lang=js"

import "./SearchIndividualStudent.vue?vue&type=style&index=0&id=79735df3&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79735df3"]])

export default __exports__